/**
 * Metafield color swatches (custom.colors).
 * With a Color variant option: also syncs to that option.
 * Without one: selection is submitted as properties[Color] via radio inputs.
 */
(function () {
  function getProductForm(element) {
    return element.closest(".ProductForm") || element.closest('form[action*="/cart/add"]');
  }

  function syncMetafieldColorLabel(container, colorName) {
    if (!container || !colorName) return;

    var selectedLabel = container.querySelector("[data-metafield-color-selected]");
    if (selectedLabel) {
      selectedLabel.textContent = colorName;
    }

    var matched = false;

    container.querySelectorAll(".MetafieldColorSwatch__Radio").forEach(function (radio) {
      var label = radio.nextElementSibling;
      var isActive = radio.value === colorName;

      if (isActive) {
        matched = true;
      }

      radio.checked = isActive;

      if (label && label.classList.contains("ColorSwatch")) {
        label.classList.toggle("is-active", isActive);
      }
    });

    if (!matched) {
      var firstRadio = container.querySelector(".MetafieldColorSwatch__Radio");
      if (firstRadio) {
        firstRadio.checked = true;
        var firstLabel = firstRadio.nextElementSibling;
        if (firstLabel && firstLabel.classList.contains("ColorSwatch")) {
          firstLabel.classList.add("is-active");
        }
        if (selectedLabel) {
          selectedLabel.textContent = firstRadio.value;
        }
      }
    }
  }

  function selectColorOption(form, optionPosition, colorName) {
    if (!form || !optionPosition || !colorName) return;

    var radios = form.querySelectorAll(
      '.ColorSwatch__Radio[data-option-position="' + optionPosition + '"]'
    );

    radios.forEach(function (radio) {
      if (radio.value === colorName && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function handleMetafieldColorChange(input) {
    var container = input.closest(".ProductForm__MetafieldColors");
    if (!container) return;

    var form = getProductForm(input);
    var colorName = input.value;

    syncMetafieldColorLabel(container, colorName);

    var optionPosition = container.getAttribute("data-color-option-position");
    if (optionPosition) {
      selectColorOption(form, optionPosition, colorName);
    }
  }

  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input.matches(".MetafieldColorSwatch__Radio")) return;
    handleMetafieldColorChange(input);
  });

  document.addEventListener("variant:changed", function (event) {
    var form = event.target.closest ? event.target.closest(".ProductForm") : null;
    if (!form) return;

    var container = form.querySelector(".ProductForm__MetafieldColors");
    if (!container) return;

    var optionPosition = container.getAttribute("data-color-option-position");
    if (!optionPosition) return;

    var checkedRadio = form.querySelector(
      '.ColorSwatch__Radio[data-option-position="' + optionPosition + '"]:checked'
    );

    if (!checkedRadio) return;

    var metafieldRadios = container.querySelectorAll(".MetafieldColorSwatch__Radio");

    metafieldRadios.forEach(function (radio) {
      if (radio.value === checkedRadio.value) {
        syncMetafieldColorLabel(container, radio.value);
      }
    });
  });

  function initMetafieldColorForms() {
    document.querySelectorAll(".ProductForm__MetafieldColors").forEach(function (container) {
      var checkedRadio = container.querySelector(".MetafieldColorSwatch__Radio:checked");

      if (!checkedRadio) {
        checkedRadio = container.querySelector(".MetafieldColorSwatch__Radio");
        if (checkedRadio) {
          checkedRadio.checked = true;
        }
      }

      if (checkedRadio) {
        handleMetafieldColorChange(checkedRadio);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMetafieldColorForms);
  } else {
    initMetafieldColorForms();
  }
})();
